import { Address } from '../../generated'

interface AddressTableProps {
  addresses: Address[]
  onEdit: (address: Address) => void
  onRemove: (payload: { addressId: string; name: string }) => void
}

interface AddressRowProps {
  address: Address
  onEdit: AddressTableProps['onEdit']
  onRemove: AddressTableProps['onRemove']
}

const composeReadableAddress = (address: Address) =>
  [
    address.addressLine1,
    address.addressLine2,
    `${address.city}, ${address.state} ${address.zip}`,
  ]
    .filter(Boolean)
    .join(', ')

const AddressRow = ({ address, onEdit, onRemove }: AddressRowProps) => (
  <tr>
    <td className="w-[40%] pr-3 pl-4 py-4 text-sm whitespace-normal text-gray-700 sm:pl-0">
      <button
        type="button"
        onClick={() => onEdit(address)}
        className="group flex w-full cursor-pointer items-center gap-3 text-left">
        {address.logoUrl ? (
          <img
            src={address.logoUrl}
            alt=""
            className="size-10 flex-shrink-0 rounded-md object-cover ring-1 ring-gray-200"
          />
        ) : null}
        <div>
          <p className="font-medium text-gray-900 group-hover:text-indigo-600">
            {address.name}
          </p>
          <p className="text-gray-400 font-normal group-hover:text-indigo-500">
            {composeReadableAddress(address)}
          </p>
        </div>
      </button>
    </td>
    <td className="relative pr-4 pl-3 align-middle text-right text-sm whitespace-nowrap sm:pr-0">
      <button
        type="button"
        onClick={() => onEdit(address)}
        className="mr-4 text-indigo-600 hover:text-indigo-900">
        Edit
      </button>
      <button
        type="button"
        onClick={() =>
          onRemove({ addressId: String(address.id), name: address.name })
        }
        className="text-red-600 hover:text-red-800">
        Remove
      </button>
    </td>
  </tr>
)

const AddressTable = ({ addresses, onEdit, onRemove }: AddressTableProps) => (
  <table className="min-w-full divide-y divide-gray-300">
    <thead className="sr-only">
      <tr>
        <th scope="col">Address</th>
        <th scope="col">Edit</th>
      </tr>
    </thead>
    <tbody className="divide-y divide-gray-200">
      {addresses.map((address) => (
        <AddressRow
          key={address.id}
          address={address}
          onEdit={onEdit}
          onRemove={onRemove}
        />
      ))}
    </tbody>
  </table>
)

export default AddressTable
